import { AppLanguage } from '../i18n/types';
import { translateCustomerPortal } from '../i18n/customerPortal';

export const CUSTOMER_NOTIFICATION_SENDER = 'Thermowool';
export const CUSTOMER_NOTIFICATION_SENDER_INITIALS = 'TW';

/** Re-localize legacy Serbian shipment notifications stored before i18n. */
export function translateShipmentNotificationMessage(lang: AppLanguage, message: string): string {
  if (lang === 'sr') return message;

  const unitFromSr = (unit: string) => {
    const key = unit.toLowerCase();
    if (key === 'paleta') return translateCustomerPortal(lang, 'unit.paleta');
    if (key === 'kom') return translateCustomerPortal(lang, 'unit.kom');
    return unit;
  };

  const single = message.match(/^Poslata vam je roba: (.+) — (.+?) \(([\d.]+) m²\)$/);
  if (single) {
    const [, product, qtyUnit, m2] = single;
    const qtyMatch = qtyUnit.trim().match(/^([\d.]+)\s+(\S+)$/);
    if (qtyMatch) {
      return translateCustomerPortal(lang, 'notify.single', {
        product,
        quantity: qtyMatch[1],
        unit: unitFromSr(qtyMatch[2]),
        m2
      });
    }
  }

  const batch = message.match(/^Nova isporuka \((.+?)\):\s*(.+?)\s*Ukupno:\s*([\d.]+) m²$/);
  if (batch) {
    const [, date, linesPart, total] = batch;
    const lines = linesPart.replace(/(\d+(?:\.\d+)?)\s+paleta/g, (_m, qty) =>
      `${qty} ${translateCustomerPortal(lang, 'unit.paleta')}`
    );
    return translateCustomerPortal(lang, 'notify.batch', {
      date,
      lines: lines.trim(),
      total
    });
  }

  return message;
}

export function formatCustomerRelativeTime(lang: AppLanguage, iso: string): string {
  try {
    const d = new Date(iso);
    const now = Date.now();
    const diff = Math.max(0, now - d.getTime());
    const sec = Math.floor(diff / 1000);
    if (sec < 60) return translateCustomerPortal(lang, 'time.justNow');
    const min = Math.floor(sec / 60);
    if (min < 60) return translateCustomerPortal(lang, 'time.minutesAgo', { count: String(min) });
    const hr = Math.floor(min / 60);
    if (hr < 24) return translateCustomerPortal(lang, 'time.hoursAgo', { count: String(hr) });
    const day = Math.floor(hr / 24);
    if (day === 1) return translateCustomerPortal(lang, 'time.yesterday');
    if (day < 7) return translateCustomerPortal(lang, 'time.daysAgo', { count: String(day) });
    if (day < 30) {
      const w = Math.floor(day / 7);
      return translateCustomerPortal(lang, 'time.weeksAgo', { count: String(w) });
    }
    const locale = { sr: 'sr-RS', en: 'en-GB', de: 'de-DE', pl: 'pl-PL', cs: 'cs-CZ', fr: 'fr-FR' }[lang];
    return d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
  } catch {
    return iso;
  }
}
